import { Text } from '@simplywallst/ui-core';
import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

interface PlanProps {
  planType: string;
  couponId: string;
}

const freeGradient = css`
  rgba(251, 254, 255, 1) 0%,
  rgba(242, 250, 255, 1) 100%
`;
const premiumGradient = css`
  rgba(253, 254, 255, 1) 0%,
  rgba(233, 246, 255, 1) 100%
`;
const unlimitedGradient = css`
  rgba(240, 249, 255, 1) 0%,
  rgba(214, 238, 254, 1) 100%
`;
const getPlanTypeGradient = (planType: string) => {
  if (planType === 'free') return freeGradient;
  if (planType === 'premium') return premiumGradient;
  return unlimitedGradient;
};

export const BackgroundImage = styled('div')<PlanProps>`
  position: relative;
  background: linear-gradient(
    180deg,
    ${({ planType }) => getPlanTypeGradient(planType)}
  );
  p mark {
      font-size: 28px;
      font-weight: 700;
      background-color: transparent;
      color: ${({ theme, couponId, planType }) =>
        couponId !== '' && planType !== 'free'
          ? theme.color.chart06
          : theme.color.spaceGray};
    }
  }
`;

interface FeatureItemProps {
  notIncluded: boolean;
}

interface AddedFeaturesProps {
  darkBackground: boolean;
}

interface FeatureItemProps {
  notIncluded: boolean;
}

export const AddedFeatures = styled('ul')<AddedFeaturesProps>`
  margin-top: 16px;
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
  ${({ theme }) => theme.typography.base}
  ${media.mdUp`
  margin-top: 0;
`}
> li {
    ${media.mdUp`
      display: inline;
    `}
  }
  ${({ darkBackground }) =>
    darkBackground &&
    css`
      li {
        color: ${({ theme }) => theme.color.white};
      }
    `}
`;

export const FeatureItem = styled('li')<FeatureItemProps>`
  ${({ theme }) => theme.typography.small}
  ${({ notIncluded }) => notIncluded && 'opacity: 0.5;'}
width: fit-content;
  svg {
    fill: ${({ theme, notIncluded }) =>
      notIncluded ? theme.color.charcoalRGBA(1) : theme.color.brand01};
    vertical-align: middle;
    margin-right: 0.8rem;
    margin-bottom: 2px;
    width: 2.4rem;
  }
  div {
    display: flex;
  }
`;

export const StyledText = styled(Text)<{ darkBackground: boolean }>`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme, darkBackground }) =>
    darkBackground ? theme.color.textSubtle : theme.color.spaceGrayRGBA(0.7)};
  border-bottom: 1px dotted
    ${({ theme, darkBackground }) =>
      darkBackground ? theme.color.textSubtle : theme.color.spaceGrayRGBA(0.7)};
`;
